/**
 * SCRUM-481 — contrato de error para negación por PERMISO/ROL, hermano de
 * plan-api-errors.ts (negación por PLAN/NICHO). Antes de esto, un 403 por
 * falta de permiso llegaba al cliente como `{ error: string }` plano, sin
 * `code` — indistinguible por contrato de un 403 cualquiera, así que cada
 * pantalla lo manejaba con un toast genérico en vez de una explicación
 * consistente ("tu rol no incluye esto" vs "no está en tu plan"). No se
 * fusiona con PlanApiErrorPayload a propósito: son causas distintas (una la
 * resuelve un upgrade de plan, la otra el owner asignándote otro rol) y
 * FeatureLockedState ya asume "hay un plan que lo resuelve" en su copy/CTA.
 */
export type PermissionDeniedCode = "permission_denied";

export interface PermissionDeniedPayload {
  message: string;
  code: PermissionDeniedCode;
  /** El permiso/capability operativo que faltó (ej. "can_manage_catalog"). */
  feature?: string;
  requiredLevel?: string;
  effectiveLevel?: string;
}

export function parsePermissionDeniedError(data: unknown): PermissionDeniedPayload | null {
  if (!data || typeof data !== "object") return null;
  const d = data as Record<string, unknown>;
  if (d.code !== "permission_denied") return null;
  return {
    message: typeof d.error === "string" ? d.error : "Tu rol no tiene permiso para realizar esta acción",
    code: "permission_denied",
    feature: typeof d.feature === "string" ? d.feature : undefined,
    requiredLevel: typeof d.requiredLevel === "string" ? d.requiredLevel : undefined,
    effectiveLevel: typeof d.effectiveLevel === "string" ? d.effectiveLevel : undefined,
  };
}
